var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"my-6 pl-4",class:{'mx-0': _vm.$vuetify.breakpoint.smAndDown},attrs:{"icon":"mdi-lightbulb-on-20","prominent":"","text":"","type":"info"}},[_c('p',{staticClass:"ma-0 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('labels.hint'))+": ")]),_c('span',[_vm._v(_vm._s(_vm.alertText || _vm.$t('alerts.change-settings')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }